App.controller('LifeConfirmationCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', 'statesService', '$q', '$filter', 'lifeInsuranceService', '$timeout', '$mdDialog', 'Config', 'popUpService', function ($scope, $sce, $state, $http, packageService, $stateParams, statesService, $q, $filter, lifeInsuranceService, $timeout, $mdDialog, Config, popUpService) {

    $scope.stateParams = $stateParams;

    $scope.page = 'life';
    $scope.$emit('page', $scope.page);

    $scope.step = '';
    $scope.$emit('step', $scope.step);

    // $scope.link = 'root.dashboard';
    // $scope.$emit('link', $scope.link);

    if ($scope.stateParams.persons && $scope.stateParams.choose) {
        $scope.person = $scope.stateParams.person;
        $scope.persons = $scope.stateParams.persons;
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.partner = $scope.stateParams.partner;
        $scope.assured = $scope.stateParams.assured;
        $scope.summary = $scope.stateParams.summary;
        $scope.isAssured = $scope.stateParams.isAssured;
        $scope.isPartner = $scope.stateParams.isPartner;
    } else {
        return $state.go('root.life.start');
    }

    $scope.fields = [
        {
            "name": "Śmierć ubezpieczonego"
        },
        {
            "name": "Śmierć w następstwie NW"
        },
        {
            "name": "Zgon ubezpieczonego spowodowany długim zdaniem, które nie mieści się w jenej linijce"
        }
    ];

    packageService.dataLifeList().then(function (data) {
        $scope.lifePackages = data.data.group;
        assignPackageInfoToPersons($scope.persons, $scope.choose, $scope.lifePackages, $scope.packagesInfoForPersons);
    });

    $scope.accept = function() {
        $scope.form.$setSubmitted();
        $scope.next($scope.form);
    };

    $scope.next = function () {
        var vm = this;

        var el = $('.bottominfo .button.right');

        if (el.hasClass('disabled')) {
            return 0;
        } else {
            el.addClass('disabled');
        }

        if (!vm.form.$valid) {
            // $scope.showPopUp('', 'Uzupełnij pola', 'Aby dokończyć rejestrację wypełnij wszystkie wymagane pola.', '');
            // document.body.scrollTop = document.documentElement.scrollTop = 80;
            return 0;
        }
        var toSave = {
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary,
            assured: $scope.assured,
            partner: $scope.partner,
            person: $scope.person,
            persons: $scope.persons,
            isAssured: $scope.isAssured,
            isPartner: $scope.isPartner
        };

        var userObject = angular.fromJson(window.sessionStorage.getItem('userObject'));

        var data = $filter('preparePersonsData')(toSave, userObject.branch.id);

        lifeInsuranceService.saveDeclarations(data).then(function (success) {
            toSave = {
                choose: null,
                prices: null,
                summary: $scope.summary,
                assured: null,
                partner: null,
                person: null,
                persons: null,
                isAssured: null,
                isPartner: null,
                saveResponse: success.data
            };

            $state.go('root.life.summary', toSave);
        }, function (error) {
            toSave.saveResponse = null;
            popUpService.showPopUpWithError(error.data, {head: 'Wystąpił błąd', content: 'Nie udało się zapisać deklaracji, prosimy spróbować ponownie później.'});

            $timeout(function() {
                el.removeClass('disabled');
            }, 1500);
        });
    };


    function assignPackageInfoToPersons(list, choose, lifePackages, packagesInfoForPersons) {
        angular.forEach(choose, function (chosen, personKey) {
            if (typeof list[personKey] === "undefined") {
                return;
            }
            var variantsTitle = '';
            var variants = [];
            angular.forEach(chosen, function (group, groupKey) {
                var pkgGroup = lifePackages[groupKey];
                if (typeof pkgGroup === "undefined") {
                    return;
                }
                angular.forEach(group, function (choice, choiceKey) {
                    var pkg = pkgGroup['item'][choiceKey];
                    var variant = {
                        price: pkg.price,
                        name: pkgGroup.name + (pkg.name ? (' ' + pkg.name) : '')
                    };
                    variants.push(variant);

                    variantsTitle += variant.name + ' ' + variant.price + ' zł, ';
                });
            });

            packagesInfoForPersons[personKey] = {
                variants: variants,
                variantsTitle: variantsTitle.slice(0, -2)
            };
        });
    }

    $scope.isShowAllDeclarations = false;
    $scope.showAllDeclarations = function (e) {
        e.stopPropagation();
        $scope.isShowAllDeclarations = true;
    };
    $scope.hideAllDeclarations = function () {
        $scope.isShowAllDeclarations = false;
    };

    $scope.data = {};
    $scope.data.agreements = [
        {
            id: 0,
            content: '<span>Chcę przystąpić do Klubu na warunkach określonych w <a href="Files/life/regulamin_pzu_pomoc.pdf" target="_blank" class="link">Regulaminie Klubu</a>. Zapoznałam/em się z jego treścią i akceptuję go.</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 1,
            content: '<span>Chcę zostać objęta/y ochroną ubezpieczeniową z sumą ubezpieczenia i na warunkach określonych w umowie, które zostały mi doręczone przed przystąpieniem do ubezpieczenia.</span></span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 2,
            content: '<span>Zgadzam się na założenie przez PZU Życie SA dedykowanego konta elektronicznego (trwały nośnik), na które mogę otrzymywać dokumenty ubezpieczenia, powiadomienia, wnioski i oświadczenia oraz poprzez które mogę zawierać lub przystępować do innych umów ubezpieczenia. Zapoznałam/em się z Regulaminem świadczenia usług drogą elektroniczną i akceptuję jego treść. Zgadzam się na otrzymywanie powiadomień o zmianach zawartości konta za pośrednictwem środków komunikacji elektronicznej (w tym wiadomości sms lub e-mail).',
            accepted: false,
            required: false
        },
        {
            id: 3,
            content: '<span>W razie wystąpienia zdarzenia upoważniam kierownictwo wszystkich placówek służby zdrowia i lekarzy do udzielania PZU Życie SA informacji o moim stanie zdrowia i stanie zdrowia moich małoletnich dzieci, w tym obejmujących: przyczyny hospitalizacji i leczenia ambulatoryjnego, wyniki badań diagnostycznych (z wyłączeniem badań genetycznych), przeprowadzonych konsultacji, wyniki leczenia i rokowań, a także do przekazania kopii mojej dokumentacji medycznej i dokumentacji medycznej moich małoletnich dzieci. Upoważnienie to jest potrzebne, aby ustalić odpowiedzialność zakładu ubezpieczeń z tytułu zdarzeń objętych ubezpieczeniem i wysokość świadczenia lub przyczynę śmierci. W razie wystąpienia zdarzenia upoważniam Narodowy Fundusz Zdrowia do przekazania do PZU Życie SA nazw i adresów świadczeniodawców, którzy udzielili mi lub moim małoletnim dzieciom świadczeń opieki zdrowotnej. Upoważnienie to jest potrzebne, aby ustalić odpowiedzialność PZU Życie SA oraz wysokość świadczenia. Powyższe upoważnienia obejmują przekazanie informacji lub dokumentacji medycznej również po mojej śmierci lub po śmierci moich małoletnich dzieci.</span></span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 4,
            content: '<span>Zgadzam się na udostępnienie moich danych osobowych i ich dalsze przetwarzanie przez świadczeniodawcę PZU Zdrowie SA, oraz dalsze przekazanie tych danych własnym lub współpracującym placówkom medycznym w celu podjęcia wszelkich działań związanych z organizacją i realizacją świadczeń wynikających z wybranego przeze mnie zakresu świadczeń zdrowotnych.</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 5,
            content: '<span>W dniu podpisania deklaracji przystąpienia nie przebywam na zwolnieniu lekarskim, w szpitalu, hospicjum, placówce dla przewlekle chorych, na świadczeniu rehabilitacyjnym oraz nie uznano w stosunku do mnie niezdolności do pracy lub niezdolności do służby orzeczeniem właściwego organu (nie stosuje się w grupowym ubezpieczeniu PZU W RAZIE WYPADKU).</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 6,
            content: '<span>Dodatkowe oświadczenie dotyczące zdrowia, składane wyłącznie przez MAŁŻONKA, PARTNERA ŻYCIOWEGO i PEŁNOLETNIE DZIECKO, przystępujących do grupowego ubezpieczenia typ P Plus o kodzie PTGP34 oraz ubezpieczeń dodatkowych, którzy bezpośrednio przed przystąpieniem do ubezpieczenia albo nie byli objęci innym ubezpieczeniem grupowym na życie w PZU Życie SA, albo byli objęci takim ubezpieczeniem krócej niż 12 miesięcy.</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 7,
            content: '<span>Wyrażam zgodę na przetwarzanie przez PZU Życie SA moich danych osobowych dotyczących stanu zdrowia zawartych w deklaracji przystąpienia do ubezpieczenia – w celu przystąpienia oraz wykonywania umowy ubezpieczenia, a także przekazanych PZU Życie SA przez placówki służby zdrowia, lekarzy lub przeze mnie w trakcie obowiązywania umowy ubezpieczenia – w celu wykonania umowy ubezpieczenia. Zgoda jest dobrowolna, ale konieczna w celu realizacji umowy.</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 8,
            content: '<span>Wyrażam zgodę na udostępnienie przez PZU Życie SA moich danych osobowych podmiotom z grupy PZU, tj. PZU SA, PTE PZU SA, TFI PZU SA, PZU Pomoc SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA, w ich własnych celach marketingowych, obejmujących profilowanie zmierzające do określenia preferencji lub potrzeb w zakresie produktów ubezpieczeniowych i innych produktów finansowych oraz przedstawienia odpowiedniej oferty.</span>',
            accepted: false,
            required: false
        },
        {
            id: 9,
            content: '<span>Wyrażam zgodę na otrzymywanie od PZU SA, PZU Życie SA, PTE PZU SA, TFI PZU SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA informacji marketingowych za pośrednictwem środków komunikacji elektronicznej (e-mail, SMS/MMS).</span>',
            accepted: false,
            required: false
        },
        {
            id: 10,
            content: '<span>Wyrażam zgodę na otrzymywanie od PZU Pomoc SA, oraz jej partnerów handlowych informacji marketingowych za pośrednictwem środków komunikacji elektronicznej (e-mail, SMS/MMS).</span>',
            accepted: false,
            required: false
        },
        {
            id: 11,
            content: '<span>Wyrażam zgodę na otrzymywanie od PZU SA, PZU Życie SA, PTE PZU SA, TFI PZU SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA informacji marketingowych za pośrednictwem połączeń głosowych (rozmowa telefoniczna, komunikaty głosowe IVR).</span>',
            accepted: false,
            required: false
        },
        {
            id: 12,
            content: '<span>Wyrażam zgodę na otrzymywanie od PZU Pomoc SA i jej partnerów handlowych informacji marketingowych za pośrednictwem połączeń głosowych (rozmowa telefoniczna, komunikaty głosowe IVR).</span>',
            accepted: false,
            required: false
        },
        {
            id: 13,
            content: '<span>Wyrażam zgodę na przetwarzanie moich danych osobowych przez PZU Życie SA w celu przekazywania mi treści marketingowych dotyczących produktów ubezpieczeniowych i innych produktów finansowych, kiedy nie będę posiadać ubezpieczenia w tej firmie.</span>',
            accepted: false,
            required: false
        },
        {
            id: 14,
            content: '<span>Wyrażam zgodę na przesyłanie informacji, które mają związek z moim ubezpieczeniem w PZU Życie SA za pośrednictwem środków komunikacji elektronicznej, w tym wiadomości SMS/MMS lub e-mail, na wskazany przeze mnie numer telefonu lub adres mailowy. W razie zmiany podanych przeze mnie danych kontaktowych, zobowiązuję się uaktualniać moje dane, dzięki którym będę otrzymywać informacje za pośrednictwem środków komunikacji elektronicznej.</span>',
            accepted: false,
            required: false
        },
        {
            id: 15,
            content: '<span>Oświadczam, że zapoznałam/em się z informacją o przetwarzaniu moich danych osobowych, zawartą w dostarczonym mi dokumencie <a href="" ng-click="showInformationObligationZycie()" class="link">Informacja Administratora danych osobowych (PZU Życie SA)</a>.</span>',
            accepted: false,
            required: true
        },
        {
            id: 16,
            content: '<span>Oświadczam, że zapoznałam/em się z informacją o przetwarzaniu moich danych osobowych, zawartą w dostarczonym mi dokumencie <a href="" ng-click="showInformationObligationPomoc()" class="link">Informacja Administratora danych osobowych (PZU Pomoc SA)</a>.</span>',
            accepted: false,
            required: true
        },
    ];

    $scope.data.requiredAgreements = $scope.data.agreements.filter(function (single) {
        return single.required;
    });
    $scope.data.optionalAgreements = $scope.data.agreements.filter(function (single) {
        return !single.required;
    });

    (function prepareAgreementsForPersons(personsList, choose, agreements) {
        var agreementsList = agreements.map(function (single) {
            return {accepted: false, id: single.id};
        });
        angular.forEach(choose, function (singleChoose, chooseKey) {
            var single = personsList[chooseKey];
            if (typeof single === "undefined") {
                return;
            }
            if (single.agreements) {
                return;
            }
            single.agreements = {
                isShowAllDeclarations: false,
                acceptRequired: false,
                list: angular.copy(agreementsList),
                sameAsFirst: single.type !== 'USER'
            };
        });
    })($scope.persons, $scope.choose, $scope.data.optionalAgreements);

    $scope.packagesInfoForPersons = {};

    $scope.showInformationObligationZycie = function () {
        $scope.showPopUpInformationObligation('', 'zycie');
    };

    $scope.showInformationObligationPomoc = function () {
        $scope.showPopUpInformationObligation('', 'pomoc');
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.showPopUpInformationObligation = function (ev, tpl) {
        var tpl = 'info-obligation-' + tpl;
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/' + tpl + '.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {}
        }).then(function (data) {

        }, function () {

        });
    };
}]);
